import { ADD_PRODUCT } from "./actionTypes";

export const addProduct = (value) => {
    return {
        type: ADD_PRODUCT,
        payload: value
    };
};